import { combineReducers } from "redux";
import customizer from "./customizer/";
import auth from "./auth/";
import navbar from "./navbar/Index";
import dataListExamination from "./data-list-examination";
import user from "../../Natus/Redux/authentication/LoginReducers";
import clinicUser from "../../Natus/Redux/clinicUser/ClinicUserReducers";
import clinicInfo from "../../Natus/Redux/clinicInfo/ClinicInfoReducers";
import addveterinarian from "../../Natus/Redux/addveterinary/AddVeterinaryReducers";
import updateClinic from "../../Natus/Redux/updateClinic/UpdateClinicReducers";
import vetid from "../../Natus/Redux/updateVet/VetUserReducers";
import imageId from "../../Natus/Redux/files/UploadReducers";
import petId from "../../Natus/Redux/petInfo/PetIdReducers";
import calenderReducer from "./calendar/index";
import calenderClinic from "./calendar-clinic/index";
import dataListVaccine from "./data-list-vaccine";
import dataListLicense from "./data-list-license";
import dataListHastalarim from "./data-list-hastalarim";
import petuserreducer from "../../Natus/Redux/petuser/petuserreducer";
import ProductAddreducer from "../../Natus/Redux/productAdd/productaddresucer";
import Appointmentreducer from "../../Natus/Redux/appointment/UploadReducers";
import chatReducer from "./chat/"

const rootReducer = combineReducers({
  customizer: customizer,
  auth: auth,
  navbar: navbar,
  dataListExamination: dataListExamination,
  dataListVaccine: dataListVaccine,
  user: user,
  clinicUser: clinicUser,
  clinicInfo: clinicInfo,
  addveterinarian: addveterinarian,
  updateClinic: updateClinic,
  vetid: vetid,
  imageId: imageId,
  petId: petId,
  calendar: calenderReducer,
  calenderClinic: calenderClinic,
  dataListLicense: dataListLicense,
  dataListHastalarim:dataListHastalarim,
  petuserreducer:petuserreducer,
  ProductAddreducer:ProductAddreducer,
  Appointmentreducer:Appointmentreducer,
  chatApp: chatReducer,
});

export default rootReducer;
